import { useState } from 'react'

export const useCommentEditor = (comment, onEdit, onEmojiReaction) => {
  const [editingComment, setEditingComment] = useState(false)
  const [editText, setEditText] = useState(comment.text)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)

  const handleEditComment = () => {
    setEditingComment(true)
    setEditText(comment.text)
  }

  const handleSaveEdit = async () => {
    if (!editText.trim()) return
    await onEdit(comment._id, editText.trim())
    setEditingComment(false)
  }

  const handleCancelEdit = () => {
    setEditingComment(false)
    setEditText(comment.text)
  }

  const handleEmojiSelect = (emoji) => {
    onEmojiReaction(comment._id, emoji)
    setShowEmojiPicker(false)
  }

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker)
  }

  const closeEmojiPicker = () => {
    setShowEmojiPicker(false)
  }

  return {
    // State
    editingComment,
    editText,
    showEmojiPicker,

    // Text editing
    setEditText,
    handleEditComment,
    handleSaveEdit,
    handleCancelEdit,

    // Emoji reactions
    handleEmojiSelect,
    toggleEmojiPicker,
    closeEmojiPicker
  }
}